import { State, StateService } from 'navigator-header';
import { publish } from 'ert-framebus';
import { PubSubMessages } from '../../../config';

export class StateServiceImpl implements StateService {

    createState(projectId: string, productCode: string, destinationUrl?: string): Promise<string> {
        return new Promise((resolve, reject) => {
            publish(PubSubMessages.createState, projectId, productCode, destinationUrl, resolve, reject);
        });
    }

    setState(state: string | State): void {
        publish(PubSubMessages.setState, state, false);
    }

    createStateByStudyNumber(studyNumber: string, destinationUrl?: string): Promise<string> {
        return new Promise((resolve, reject) => {
            publish(PubSubMessages.createStateByStudyNumber, studyNumber, destinationUrl, resolve, reject);
        });
    }
}
